import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { Row } from '@/components/SettingsLayout';
import { Button, Input } from '@/ui';

type FilterFormValues = {
  search: string;
};

type Props = {
  onFiltersChange: (filters: { search?: string }) => void;
};

function ApiKeysFilters({ onFiltersChange }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { control, watch } = useForm<FilterFormValues>({
    defaultValues: {
      search: '',
    },
  });

  const searchValue = watch('search');

  useEffect(() => {
    onFiltersChange({ search: searchValue });
  }, [searchValue, onFiltersChange]);

  const handleNewKey = () => {
    navigate(`${pathname}?mode=new-api-key`);
  };

  return (
    <Row justify='justify-between' align='center'>
      <div className='w-[300px]'>
        <Controller
          name='search'
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              placeholder={t('ApiKeys.search_placeholder')}
              variant='search'
              testId='api-keys-search'
              sanitize={false}
            />
          )}
        />
      </div>
      <Button variant='primary' onClick={handleNewKey} testId='new-api-key'>
        {t('ApiKeys.new_key')}
      </Button>
    </Row>
  );
}

export default ApiKeysFilters;
